export default __webpack_public_path__ + "static/media/fast-food.5acaf4b9.svg";